/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProjectDocumentationEnum = 1 | 2 | 3 | 4;

export const ProjectDocumentationEnum = {
    NUMBER_1: 1 as ProjectDocumentationEnum,
    NUMBER_2: 2 as ProjectDocumentationEnum,
    NUMBER_3: 3 as ProjectDocumentationEnum,
    NUMBER_4: 4 as ProjectDocumentationEnum
};

